import { useOperation } from "./OperationContext";
import { HttpError } from "../Services/ApiClient";
import ErrorIcon from '@mui/icons-material/Error';
import { Fragment } from "react";
import { networkMonitor } from "../Services/NetworkMonitor";
import { useInitAsync } from "../Utils";
import { appSettings } from "../AppSettings";

interface INetworkOptions {
    isLocal?: boolean;
    showBigError?: boolean;
    disableRetry?: boolean;
}

export function useOnlineCheck() {

    const operation = useOperation();

    return async () => {

        if (!appSettings.offlineMode)
            return;

        const curOffline = networkMonitor.isOffline;

        await networkMonitor.checkNetworkAsync(true);

        if (curOffline != networkMonitor.isOffline) {
            if (networkMonitor.isOffline)
                operation.showAlert("Sei passato in modalità offline", "warning", 2000);
            else
                operation.showAlert("Sei tornato online", "info", 2000);
        }
    }
}

export function useNetwork() {

    const operation = useOperation();

    async function withNetworkAsync<T>(action: () => Promise<T>, options?: INetworkOptions): Promise<T> {

        while (true) {

            if (!options?.isLocal)
                operation.begin();

            try {
                const result = await action();
                if (!options?.isLocal)
                    operation.end();
                return result;
            }
            catch (ex) {

                let msg: string;
                if (ex instanceof HttpError) {
                    if (ex.response?.status == 404)
                        msg = "API NTC non disponibile";
                    else
                        msg = "Il server NTC ha restituito un errore. Se il problema persiste, contattare il supporto tecnico."

                    console.warn("Http Error:" + ex.response.status);

                    try {
                        const text = await ex.response.text();
                        console.warn(text);
                    }
                    catch {

                    }
                }
                else {

                    console.warn(ex);

                    if (options?.disableRetry)
                        msg = "Problemi di connessione";
                    else
                        msg = "Problemi di connessione, vuoi riprovare ad inviare la richiesta?";
                }

                if (!options?.isLocal)
                    operation.end();

                let result: "retry" | "cancel";

                if (options?.showBigError) {

                    const actions = options?.disableRetry ? {
                        "cancel": {
                            label: "ok"
                        }
                    } : {
                        "cancel": {
                            label: "No"
                        },
                        "retry": {
                            label: "Si"
                        }
                    }

                    result = await operation.showMessageAsync((<Fragment>
                        <ErrorIcon className="icon red" /> <span>{msg} </span>
                        </Fragment >), "Gate Keeper", actions);
                }
                else {
                    result = await operation.showErrorAsync(msg, {
                        "retry": {
                            label: "Riprova"
                        }
                    });
                }

                if (result != "retry")
                    return;
            }
            finally {

            }
        }
    }

    return withNetworkAsync;
}

